import React, { useEffect } from "react";
import { Redirect, Route } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
function AdminRoute({ component: Component, authed, ...rest }) {
  const { isLoggedIn, user } = useAuth();
  const history = useHistory();
  useEffect(() => {
    if (!isLoggedIn || !user || user?.role !== 1) {
      history.push("/");
    }
  }, [history, isLoggedIn, user]);
  return (
    isLoggedIn && (
      <Route
        {...rest}
        render={(props) =>
          isLoggedIn && user && user?.role === 1 ? (
            <Component {...props} />
          ) : (
            <Redirect to={{ pathname: "/", state: { from: props.location } }} />
          )
        }
      />
    )
  );
}
export default AdminRoute;
